module.exports = "/assets/data/52d94283a0008a989a83f2f4a26b9aa9-LE2.data.json";